import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    padding: theme.spacing(5),
  },
  header: {
    '& p': {
      fontSize: '16px',
      marginTop: '10px',
      color: theme.palette.secondary.gray,
    },
  },
  title: {
    fontSize: '24px',
    marginBottom: '16px',
    fontWeight: 'bold',
    color: theme.palette.primary.mainBlue,
  },
  buttonRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  paper: {
    padding: '2rem',
    marginTop: '1.5rem',
  },
  backButton: {
    width: '120px',
    height: '40px',
    paddingLeft: '0px',
    color: theme.palette.secondary.middleGray,
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'flex-start !important',
    gap: '4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      marginRight: '4px',
    },
    '& span': {
      fontSize: '13px',
      whiteSpace: 'nowrap',
      lineHeight: '16px',
    },
  },
  textField: {
    // These force full-opacity text on disabled inputs (the detail view renders
    // read-only fields). Hardcoding black made them invisible in dark mode.
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.custom.disabledInputText,
      '-webkit-text-fill-color': theme.palette.custom.disabledInputText,
    },
  },

}));

export default useStyles;
